module.exports = __webpack_public_path__ + "img/BNI.94fa0b82.svg";